export default __webpack_public_path__ + "55aa12912c9c449a581d9c85e8431103.png";